import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import Post from "../../daumPostcode/Post";
import {keepChk} from "../../../static/js/Common";
import {useAdminShopInfo, useCategory, useShopAdminDetail, useShopInfo} from "../../../static/js/hock/shopHock";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {getValue, inputLimit, inputMaxLength} from "../../../static/js/Common2";
import $ from "jquery";
import {category} from "../../../static/js/shop/ShopInfo";
import {idCheck} from "../../../static/js/service/userService";
import {newShop} from "../../../static/js/service/shopService";

export default function ShopApplicationNewV2() {
  const userData = keepChk();
  const userIdx = Number(userData[0].userId);

  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [serviceType, setServiceType] = useState(1);
  let [idCheckValue, setIdCheckValue] = useState(1);
  let [categoryList, setCategoryList] = useState([]);

  let [realName, setRealName] = useState();
  let [birth, setBirth] = useState();
  let [tel, setTel] = useState();
  let [email, setEmail] = useState();
  let [road, setRoad] = useState();
  let [jibun, setJibun] = useState();
  let [addressDetail, setAddressDetail] = useState();
  let [lat, setLat] = useState();
  let [lng, setLng] = useState();
  let [bizType, setBizType] = useState();
  let [bizNo, setBizNo] = useState();
  let [corpNo, setCorpNo] = useState();
  let [reptName, setReptName] = useState();
  let [reptTel, setReptTel] = useState();
  let [bizCond, setBizCond] = useState();
  let [bizItem, setBizItem] = useState();
  let [bank, setBank] = useState();
  let [bankAccountHolder, setBankAccountHolder] = useState();
  let [bankAccount, setBankAccount] = useState();


  useShopAdminDetail({
    setRealName, setBirth, setEmail, setRoad, setJibun,
    setAddressDetail, setLat, setLng, setBizType, setBizNo,
    setReptName, setBizCond, setBizItem, setBank,
    setBankAccountHolder, setBankAccount
  }, shopId)
  useAdminShopInfo({setCorpNo, setTel, setReptTel}, shopId);
  useCategory({setCategoryList}, serviceType);
  useEffect(() => {
    inputLimit();
  }, []);

  const newBtn = () => {
    let pwChk = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/

    let userId = getValue("shopId");
    let userPw1 = getValue("shopPw1");
    let userPw2 = getValue("shopPw2");
    let shopName = getValue("name");
    let shopTel = getValue("tel");
    let shopRoad = getValue("road");
    let shopLat = getValue("lat");
    let shopLng = getValue("lng");
    let shopJibun = getValue("jibun");
    let shppAddressDetail = getValue("addressDetail");

    if(userId === "") {
      alert("아이디를 입력해주세요.");
      return false;
    }
    if(idCheckValue === 1) {
      alert("아이디 중복확인을 해주세요.");
      return false;
    }
    if(userPw1.length < 8) {
      alert("비밀번호를 8자리 이상 입력해주세요.");
      return false;
    } else {
      if(!pwChk.test(userPw1)) {
        alert("영문,숫자,특수문자 조합으로 8자리 이상 입력해주세요.");
        return false;
      }
    }
    if(userPw1 !== userPw2) {
      alert("비밀번호가 일치하지 않습니다.");
      return false;
    }
    if(shopName === "") {
      alert("실제 상점명을 입력해주세요.");
      return false;
    }
    if(shopTel === "") {
      alert("상점 연락처를 입력해주세요.");
      return false;
    }
    if(shppAddressDetail === "") {
      alert("상세 주소를 입력해주세요.");
      return false;
    }

    let deliTy = [];

    let deliveryType = document.querySelectorAll(".deliveryType");
    deliveryType.forEach((element) => {
      if(element.checked) {
        deliTy.push(element.value);
      }
    })

    let categoryLi = document.querySelectorAll(".selectCategory");
    let categoryList = [];

    categoryLi.forEach((element) => {
      categoryList.push(Number(element.getAttribute("data-id")));
    })

    if(categoryList.length === 0) {
      alert("카테고리를 선택해주세요.");
      return false;
    }

    let data = {
      modifierId: userIdx,
      modifierType: 2,
      channelType: 2,
      userType: 4,
      loginId: userId,
      loginPassword: userPw1,
      type: 4,
      status: 8,
      approvalType1: 1,
      approvalType2: 1,
      serviceType: serviceType,
      upperShopId: userIdx,
      name: shopName,
      realName: realName,
      birth: birth,
      tel: tel,
      email: email,
      jibun: shopJibun,
      road: shopRoad,
      addressDetail: shppAddressDetail,
      lat: shopLat,
      lng: shopLng,
      bizAddress: shopRoad + " " + shppAddressDetail,
      bizType: bizType,
      bizNo: bizNo,
      corpNo: corpNo,
      reptName: reptName,
      reptTel: reptTel,
      bizCond: bizCond,
      bizItem: bizItem,
      bank: bank,
      bankAccountHolder: bankAccountHolder,
      bankAccount: bankAccount,
      doPromotionAgree: false,
      doAutoToggleOperation: true,
      intro: "",
      notice: "",
      pauseStartDateTime: "2000-01-01 09:00:00",
      pauseEndDateTime: "2000-01-01 09:00:00",
      pauseReason: "",
      extraCost: 0,
      extraReason: "",
      minOrderCost: 0,
      pgId: "",
      zeroId: "",
      zeroAuthKey: "",
      onnuriId: "",
      onnuriAuthKey: "",
      localCurrency: 1,
      localCurrencyId: "",
      deliveryTypeList: deliTy,
      extraTypeList: [],
      packagingType: 1,
      packagingCost: 0,
      packagingDiscountCost: 0,
      tempClosingStartDate: "2000-01-01",
      tempClosingEndDate: "2000-01-01",
      tempClosingReason: "",
      deliveryDoneMinutes: 0,
      packagingDoneMinutes: 0,
      bundleDoneMinutes: 0,
      cooInfo: "",
      etc: "",
      categoryIdList: categoryList
    }

    newShop(data);
  }

  const addCategory = (id, name) => {
    let categoryLi = document.querySelectorAll(".selectCategory");
    let result = true;

    if(categoryLi.length > 2) {
      alert('카테고리는 최대 3개까지 선택할 수 있습니다.');
      return false;
    }

    categoryLi.forEach((element) => {
      if(element.getAttribute("data-id") === id) {
        alert('동일한 카테고리는 선택할 수 있습니다.');
        result = false;
      }
    })

    if(result) {
      createCategory(id, name);
    }
  }
  const createCategory = (id, name) => {
    let li = document.createElement("li");
    let categoryListBox = document.getElementById("categoryListBox");

    li.innerHTML =  `${name}<button type="button" class="eventBtn deleBtn">X</button>`;
    li.setAttribute("class", "selectCategory");
    li.setAttribute("data-id", id);
    categoryListBox.appendChild(li);

    li.querySelector("button").addEventListener("click", () => {
      li.remove();
    })
  }

  let categoryBox = categoryList.map((value) => {
    return (
      <option value={value.id} key={value.id}>{value.categoryName}</option>
    )
  })

  const idCheckEvent = async () => {
    let loginId = getValue("shopId");
    let result = await idCheck(loginId);

    if(loginId.length < 6) {
      alert("아이디를 6자리 이상 입력해주세요.");
      return false;
    }

    if(result.testResult) {
      alert("사용할 수 없는 아이디입니다.");
      setIdCheckValue(1);
    } else {
      alert("사용가능한 아이디입니다.");
      setIdCheckValue(2);
    }
  }

  return (
    <main id="ShopApplicationNewV2" className="mainV2">
      <TopBoxV2 navGrp="shopNav" navName="shop4" shopList={shopList} />

      <div className="container">
        <section className='containerInner'>
          <PageNameV2 title1='상점 관리' title2='상점 신규 신청' />
          <div id='pageTitle'>
            <PageTitleV2 title='상점 신규 신청' countText='' count='' unit='' />
          </div>
          <div className="topMenu hide">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/shopInfo1" setShopId={setShopId} setShopList={setShopList} />
            </div>
          </div>

          <div className="infoBox">
            <div className='infoBoxTitle font17 fontB'>사업자 정보</div>
            <div className='infoContainer'>
              <div className='infoTitle'>아이디</div>
              <div className='infoInputBox'>
                <input
                  type='text' name='shopId' id='shopId' className="eng"
                  placeholder='영문, 숫자 포함 6자 이상' maxLength={16}
                  onInput={(e) => inputMaxLength(e)}
                />
                <button type='button' className='lineBtn96 marginLeft8' name='overlapChkBtn' id='overlapChkBtn' onClick={() => idCheckEvent()}>중복확인</button>
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>비밀번호</div>
              <div className='infoInputBox'>
                <input
                  type='password' name='shopPw1' id='shopPw1'
                  maxLength={16} placeholder='영문, 숫자, 특수문자 포함 8자 이상'
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='infoContainer bottomLine'>
              <div className='infoTitle'>비밀번호 재입력</div>
              <div className='infoInputBox'>
                <input
                  type='password' name='shopPw2' id='shopPw2'
                  maxLength={16} placeholder='비밀번호 재입력'
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>실제 상점명</div>
              <div className='infoInputBox'>
                <input
                  type='text' name='name' id='name'
                  maxLength={30} placeholder='실제 사용하는 상점명'
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>서비스 유형</div>
              <div className='infoInputBox'>
                <input
                  type='radio' name='serviceTp' className='infoRadio serviceTp'
                  value={1} id='serviceTp1' defaultChecked onChange={() => {
                  setServiceType(1);
                  document.getElementById("categoryListBox").innerHTML = "";
                }}
                />
                <label htmlFor='serviceTp1' className={`marginRight15 serviceTpLabel serviceTpLabel1 ${serviceType === 1 ? "active" : ""}`}>배달/포장</label>
                <input
                  type='radio' name='serviceTp' className='infoRadio serviceTp'
                  value={6} id='serviceTp3' onChange={() => {
                  setServiceType(6);
                  document.getElementById("categoryListBox").innerHTML = "";
                }}
                />
                <label htmlFor='serviceTp3' className={`marginRight15 serviceTpLabel serviceTpLabel6 ${serviceType === 6 ? "active" : ""}`}>택배배송</label>
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>상점 연락처</div>
              <div className='infoInputBox'>
                <input
                  type='number' name='tel' id='tel'
                  maxLength={11} defaultValue={tel}
                  onInput={(e) => inputMaxLength(e)}
                />
              </div>
            </div>
            <div className='infoContainer bottomLine'>
              <div className='infoTitle'>상점 주소</div>
              <div className='infoInputBox'>
                <Post />
                <input type='text' name='road' id='road' className='marginLeft8' readOnly={true} defaultValue={road} />
                <input type='hidden' name='lat' id='lat' defaultValue={lat} />
                <input type='hidden' name='lng' id='lng' defaultValue={lng} />
                <input type='hidden' name='jibun' id='jibun' defaultValue={jibun} />
                <input type='text' name='addressDetail' id='addressDetail' className='marginLeft8' defaultValue={addressDetail} />
              </div>
            </div>
          </div>

          <div className='infoBox'>
            <div className='infoBoxTitle font17 fontB'>입점 정보</div>
            <div className='infoContainer'>
              <div className='infoTitle'>카테고리<span>(1개 이상)</span></div>
              <div className='infoInputBox'>
                <select name='categorySelectBox' id='categorySelectBox'>
                  {categoryBox}
                </select>
                <button
                  type='button' id='addCategory' className='lineBtn96 marginLeft8'
                  onClick={(e) => {
                    const categorySelectBox = document.getElementById('categorySelectBox');
                    let result = categorySelectBox.options[categorySelectBox.selectedIndex];
                    addCategory(result.value, result.text);
                  }}
                >추가</button>
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'></div>
              <div className='infoInputBox'>
                <ul id='categoryListBox'>

                </ul>
              </div>
            </div>
            <div className='infoContainer last'>
              <div className='infoTitle'>배송방법<span>(중복 가능)</span></div>
              <div className='infoInputBox'>
                {serviceType === 1 &&
                  <>
                    <input type='checkbox' className='inputChk deliveryType modiShop modiMarket' value={1} id='deliveryType1' />
                    <label htmlFor='deliveryType1' className='checkboxLabel modiShop modiMarket marginRight18'>배달주문</label>
                    <input type='checkbox' className='inputChk deliveryType modiShop' value={2} id='deliveryType2' />
                    <label htmlFor='deliveryType2' className='checkboxLabel modiShop marginRight18'>포장주문</label>
                  </>
                }
                {serviceType === 6 &&
                  <>
                    <input type='checkbox' className='inputChk deliveryType modiMall' value={4} id='deliveryType4' />
                    <label htmlFor='deliveryType4' className='checkboxLabel modiMall'>택배배송</label>
                  </>
                }
              </div>
            </div>
          </div>
          <div className='infoBottomBtnBox'>
            <button type='button' id='shopAddBtn' className='infoBottomBtn' onClick={() => newBtn()}>신청하기</button>
          </div>
        </section>
      </div>
    </main>
  )
}